﻿import {createContext, JSX, ReactNode, useContext, useState} from "react";

type FilteredItemsContextType<T> = {
	source: T[];
	filtered: T[];
	setFiltered: (filtered: T[]) => void;
}

const FilteredItemsContext = createContext<FilteredItemsContextType<any> | null>(null);

type FilteredItemsProviderProps<T> = {
	children: ReactNode;
	items: T[];
}

export function FilteredItemsProvider<T>(props: FilteredItemsProviderProps<T>): JSX.Element {
	const {children, items} = props;
	const [filteredItems, setFilteredItems] = useState<T[]>(() => items);

	return (
		<FilteredItemsContext.Provider value={{source: items, filtered: filteredItems, setFiltered: setFilteredItems}}>
			{children}
		</FilteredItemsContext.Provider>
	);
}

export function useFilteredItems<T>() {
	const context = useContext(FilteredItemsContext);
	if (!context) {
		throw new Error("useFilter must be used within a FilteredItemsContext");
	}
	return context as FilteredItemsContextType<T>;
}
